// src/pages/NotFound.jsx
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ 
      textAlign: "center", 
      padding: "80px 20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <h1 style={{ fontSize: "12rem", marginBottom: "10px", color: "#16a34a" }}>404</h1>
      <h2 style={{ marginBottom: "20px" }}>Oups ! Page non trouvée</h2>
      <p style={{ marginBottom: "30px", color: "#555" }}>
        La page que vous cherchez n’existe pas ou a été déplacée.
      </p>
      <Link to="/" style={{
        padding: "12px 24px",
        backgroundColor: "#16a34a",
        color: "#fff",
        borderRadius: "8px",
        textDecoration: "none",
        fontWeight: "600"
      }}>
        Retour à l’accueil
      </Link>
    </div>
  );
}
